import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppIcon from '../assets/sayq-fav.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft, faPaperPlane, faEnvelope, faUser,
    faBuilding, faTag, faCommentDots, faCalendarAlt,
    faMapMarkerAlt, faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

const CAL_URL = 'https://cal.com/mateusz-krosnowski-iztb2n/poznaj-aplikacje-quero';
const API = window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://api18081113.sayq.pl';

const TOPIC_OPTIONS = [
    { value: '', label: 'Wybierz temat…' },
    { value: 'Pytanie o licencję', label: '💳 Pytanie o licencję' },
    { value: 'Demo produktu', label: '🎥 Demo produktu' },
    { value: 'Współpraca / partnerstwo', label: '🤝 Współpraca / partnerstwo' },
    { value: 'Wsparcie techniczne', label: '🛠️ Wsparcie techniczne' },
    { value: 'Inne', label: '💬 Inne' },
];

export default function Contact() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: '', email: '', company: '', topic: '', message: '' });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [activeTab, setActiveTab] = useState('form');

    const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);

        try {
            const response = await fetch(`${API}/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(form),
            });

            if (response.ok) {
                setSubmitted(true);
            } else {
                setError(true);
            }
        } catch (err) {
            console.error('Contact form error:', err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const isFormValid = form.name && form.email && form.topic && form.message;

    return (
        <div style={{ background: '#f5f7fb', overflowX: 'hidden' }}>

            {/* ── Navbar ──────────────────────────────────────────────────── */}
            <nav className="navbar navbar-expand-lg bg-white bg-opacity-90 backdrop-blur fixed-top shadow-sm px-4 py-3 d-flex justify-content-between z-1000">
                <div className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
                    <img src="/sayq-fav.svg" alt="SayQ" style={{ height: 42, objectFit: 'contain', flexShrink: 0 }} />
                    <span className="fs-4" style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, letterSpacing: '-0.2px' }}>SayQ</span>
                </div>
                <div className="d-flex gap-4 align-items-center">
                    <a href="/#faq" className="text-secondary fw-semibold text-decoration-none d-none d-md-block hover-text-primary transition-all">FAQ</a>
                    <span onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-secondary fw-semibold text-decoration-none d-none d-md-block hover-text-primary transition-all" style={{ cursor: 'pointer' }}>Kontakt</span>
                    <button
                        onClick={() => navigate('/login')}
                        className="btn btn-outline-primary rounded-pill px-4 fw-bold hover-lift"
                    >
                        Panel Organizatora
                    </button>
                </div>
            </nav>

            {/* ── Hero ─────────────────────────────────────────────────────── */}
            <div style={{
                marginTop: 72,
                background: 'linear-gradient(155deg, #f0f4ff 0%, #f8f9fa 50%, #eef6ff 100%)',
                padding: '60px 20px 48px',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}>
                <div style={{ position: 'absolute', top: -80, left: -120, width: 450, height: 450, borderRadius: '50%', background: 'radial-gradient(circle, rgba(13,110,253,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: -40, right: -80, width: 350, height: 350, borderRadius: '50%', background: 'radial-gradient(circle, rgba(13,202,240,0.07) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'relative', zIndex: 1, maxWidth: 700, margin: '0 auto' }}>
                    <div className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill fw-bold mb-3" style={{ letterSpacing: '1px', fontSize: '0.75rem' }}>
                        KONTAKT
                    </div>
                    <h1 className="display-4 fw-black mb-3 text-dark">Porozmawiajmy o Twoim wydarzeniu</h1>
                    <p className="lead text-secondary fw-medium" style={{ lineHeight: 1.6 }}>
                        Napisz do nas lub wybierz wygodny termin spotkania. Odpowiadamy w ciągu jednego dnia roboczego.
                    </p>
                </div>
            </div>

            {/* ── Tab switcher (mobile only) ──────────────────────────────── */}
            <div className="d-lg-none" style={{ padding: '16px 20px 0', maxWidth: 1140, margin: '0 auto' }}>
                <div className="bg-white rounded-pill p-1 d-flex shadow-sm border" style={{ gap: 4 }}>
                    {[{ key: 'form', label: 'Formularz', icon: faEnvelope }, { key: 'calendar', label: 'Umów spotkanie', icon: faCalendarAlt }].map(tab => (
                        <button key={tab.key} onClick={() => setActiveTab(tab.key)}
                            className={`btn rounded-pill fw-bold flex-grow-1 ${activeTab === tab.key ? 'btn-primary' : 'btn-white text-secondary'}`}
                            style={{ transition: 'all 0.2s' }}>
                            <FontAwesomeIcon icon={tab.icon} className="me-2" />{tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* ── Main content ─────────────────────────────────────────────── */}
            <div style={{ maxWidth: 1140, margin: '0 auto', padding: '40px 20px 60px' }}>
                <div className="row g-4 align-items-start">

                    {/* LEFT — form */}
                    <div className={`col-lg-5 ${activeTab === 'calendar' ? 'd-none d-lg-block' : ''}`}>
                        {/* Info cards */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 20 }}>
                            {[
                                { icon: faEnvelope, label: 'E-mail', value: 'kontakt@queroapp.pl', href: 'mailto:kontakt@queroapp.pl' },
                                { icon: faMapMarkerAlt, label: 'Siedziba', value: 'Warszawa, Poland', href: null },
                            ].map(item => (
                                <div key={item.label} className="bg-white rounded-4 p-3 d-flex align-items-center gap-3 shadow-sm border border-light">
                                    <div className="rounded-3 bg-primary bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 42, height: 42 }}>
                                        <FontAwesomeIcon icon={item.icon} className="text-primary" />
                                    </div>
                                    <div>
                                        <div className="text-secondary small">{item.label}</div>
                                        {item.href
                                            ? <a href={item.href} className="fw-bold text-dark text-decoration-none">{item.value}</a>
                                            : <span className="fw-bold text-dark">{item.value}</span>}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Form card */}
                        <div className="bg-white rounded-4 shadow-sm border border-light p-4 p-md-5">
                            {submitted ? (
                                <div className="text-center py-4">
                                    <div className="mb-4 text-success" style={{ fontSize: '3.5rem' }}><FontAwesomeIcon icon={faCheckCircle} /></div>
                                    <h2 className="fw-bold mb-3">Wiadomość wysłana!</h2>
                                    <p className="text-secondary mb-4 fs-5">
                                        Dziękujemy za kontakt. Odpowiemy na Twoje zapytanie najszybciej, jak to możliwe.
                                    </p>
                                    <button className="btn btn-outline-primary rounded-pill px-4 fw-bold" onClick={() => setSubmitted(false)}>Wyślij kolejną wiadomość</button>
                                </div>
                            ) : (
                                <>
                                    <h2 className="fw-black mb-1" style={{ fontSize: '1.4rem' }}>Napisz do nas</h2>
                                    <p className="text-secondary small mb-4">Odpowiemy w ciągu 24 godzin w dni robocze.</p>
                                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

                                        {error && (
                                            <div className="alert alert-danger rounded-3 small py-2 d-flex align-items-center gap-2">
                                                <div style={{ width: 18, height: 18 }} className="d-flex align-items-center justify-content-center">⚠️</div>
                                                Wystąpił błąd. Spróbuj ponownie lub napisz na kontakt@queroapp.pl
                                            </div>
                                        )}

                                        <div>
                                            <label className="form-label fw-semibold small text-dark mb-1">
                                                <FontAwesomeIcon icon={faUser} className="me-2 text-primary opacity-75" />
                                                Imię i nazwisko <span className="text-danger">*</span>
                                            </label>
                                            <input type="text" name="name" className="form-control rounded-3" placeholder="Jan Kowalski"
                                                value={form.name} onChange={handleChange} required
                                                style={{ padding: '0.65rem 1rem', borderWidth: 2 }} />
                                        </div>

                                        <div>
                                            <label className="form-label fw-semibold small text-dark mb-1">
                                                <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary opacity-75" />
                                                Adres e-mail <span className="text-danger">*</span>
                                            </label>
                                            <input type="email" name="email" className="form-control rounded-3" placeholder="jan@firma.pl"
                                                value={form.email} onChange={handleChange} required
                                                style={{ padding: '0.65rem 1rem', borderWidth: 2 }} />
                                        </div>

                                        <div>
                                            <label className="form-label fw-semibold small text-dark mb-1">
                                                <FontAwesomeIcon icon={faBuilding} className="me-2 text-primary opacity-75" />
                                                Organizacja <span className="text-secondary fw-normal">(opcjonalnie)</span>
                                            </label>
                                            <input type="text" name="company" className="form-control rounded-3" placeholder="Nazwa firmy"
                                                value={form.company} onChange={handleChange}
                                                style={{ padding: '0.65rem 1rem', borderWidth: 2 }} />
                                        </div>

                                        <div>
                                            <label className="form-label fw-semibold small text-dark mb-1">
                                                <FontAwesomeIcon icon={faTag} className="me-2 text-primary opacity-75" />
                                                Temat <span className="text-danger">*</span>
                                            </label>
                                            <select name="topic" className="form-select rounded-3" value={form.topic} onChange={handleChange} required
                                                style={{ padding: '0.65rem 1rem', borderWidth: 2 }}>
                                                {TOPIC_OPTIONS.map(opt => (
                                                    <option key={opt.value} value={opt.value} disabled={opt.value === ''}>{opt.label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="form-label fw-semibold small text-dark mb-1">
                                                <FontAwesomeIcon icon={faCommentDots} className="me-2 text-primary opacity-75" />
                                                Wiadomość <span className="text-danger">*</span>
                                            </label>
                                            <textarea name="message" className="form-control rounded-3" rows={5}
                                                placeholder="Opisz swoje potrzeby, pytania lub propozycję współpracy…"
                                                value={form.message} onChange={handleChange} required
                                                style={{ padding: '0.75rem 1rem', resize: 'vertical', borderWidth: 2 }} />
                                        </div>

                                        <button
                                            type="submit"
                                            disabled={!isFormValid || loading}
                                            className="btn btn-primary btn-lg rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 mt-2"
                                            style={{ opacity: (isFormValid && !loading) ? 1 : 0.5, transition: 'opacity 0.2s', boxShadow: '0 8px 25px rgba(13,110,253,0.28)' }}
                                        >
                                            {loading ? (
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            ) : (
                                                <FontAwesomeIcon icon={faPaperPlane} />
                                            )}
                                            {loading ? 'Wysyłanie...' : 'Wyślij wiadomość'}
                                        </button>
                                        <p className="text-secondary text-center mb-0" style={{ fontSize: '0.78rem' }}>
                                            Wiadomość zostanie wysłana bezpośrednio do naszego zespołu.
                                        </p>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>

                    {/* DIVIDER (desktop) */}
                    <div className="col-lg-1 d-none d-lg-flex flex-column align-items-center justify-content-center" style={{ minHeight: 600 }}>
                        <div style={{ flex: 1, width: 2, background: '#e9ecef' }} />
                        <div className="bg-white rounded-pill border shadow-sm px-3 py-2 my-3">
                            <span className="text-secondary fw-bold small">lub</span>
                        </div>
                        <div style={{ flex: 1, width: 2, background: '#e9ecef' }} />
                    </div>

                    {/* RIGHT — Cal.com */}
                    <div className={`col-lg-6 ${activeTab === 'form' ? 'd-none d-lg-block' : ''}`}>
                        <div className="bg-white rounded-4 shadow-sm border border-light overflow-hidden">
                            <div className="px-4 pt-4 pb-3 border-bottom border-light d-flex align-items-center gap-3">
                                <div className="rounded-3 bg-primary bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 42, height: 42 }}>
                                    <FontAwesomeIcon icon={faCalendarAlt} className="text-primary" />
                                </div>
                                <div>
                                    <h2 className="fw-black mb-0" style={{ fontSize: '1.2rem' }}>Umów spotkanie</h2>
                                    <p className="text-secondary small mb-0">Wybierz wygodny dla siebie termin 30-minutowej rozmowy.</p>
                                </div>
                            </div>
                            <iframe
                                src={`${CAL_URL}?embed=true&theme=light`}
                                title="Umów spotkanie z SayQ"
                                frameBorder="0"
                                style={{ width: '100%', height: 660, border: 'none', display: 'block' }}
                                allow="camera; microphone; fullscreen"
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* ── Footer ─────────────────────────────────────────────────── */}
            <div style={{
                borderTop: '1px solid #e9ecef',
                padding: '40px 20px',
                textAlign: 'center',
                background: '#f8f9fa',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 12 }}>
                    <img src={AppIcon} alt="SayQ" style={{ width: 28, height: 28 }} />
                    <span className="fw-bold text-dark" style={{ fontFamily: "'Nunito', sans-serif", fontSize: '1.1rem' }}>SayQ</span>
                </div>
                <p className="small text-secondary mb-2">© 2025 SayQ App. Wszystkie prawa zastrzeżone.</p>
                <p className="small mb-0">
                    <a href="mailto:kontakt@queroapp.pl" className="text-primary text-decoration-none fw-semibold">kontakt@queroapp.pl</a>
                </p>
            </div>

        </div>
    );
}
